import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'cabang?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const getListArchive = async (page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'cabang/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};
const create = async (data) => {
  return http_client.post(config.apiUrl + 'cabang', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'cabang/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'cabang/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return http_client.delete(config.apiUrl + 'cabang/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'cabang/status/' + id, data).then((response) => {
    return response.data;
  });
};

const getForOperasional = async (page = null, perPage = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'cabang/for-operasional?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const CabangService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus,
  getForOperasional
};

export default CabangService;
